import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Modal } from '@/components/ui/Modal'
import { updateRepairOrder } from '@/services/repairOrders.service'
import { toast } from '@/utils/helpers'

/**
 * PaymentReviewModal
 *
 * Shown after an RO is resolved with a mix of written-off and non-written-off
 * line items. Asks the admin whether the non-written-off items have already
 * been paid by the manufacturer.
 */
const PaymentReviewModal = ({ isOpen, setIsOpen, dealerId, repairOrderId }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleConfirm = async (alreadyPaid) => {
    const payload = alreadyPaid
      ? { status: 'Paid with Adjustments' }
      : { status: 'Closed \u2014 Submitted' }

    await updateRepairOrder(
      dealerId,
      repairOrderId,
      payload,
      setLoading,
      (message) => toast(message, 'error'),
      () => {
        toast(
          alreadyPaid
            ? 'Repair order marked as paid with adjustments.'
            : 'Repair order marked as submitted.',
          'success',
        )
        setIsOpen(false)
        navigate(`/dealer/${dealerId}/detail`)
      },
    )
  }

  return (
    <Modal
      open={isOpen}
      title="Payment Confirmation"
      setOpen={setIsOpen}
      loading={loading}
      content={
        <div className="mt-4">
          <p className="text-gray text-sm">
            This repair order was resolved with a mix of written-off and non-written-off line
            items. Have the non-written-off items already been paid by the manufacturer?
          </p>
        </div>
      }
      actions={[
        {
          type: 'cancel',
          label: 'Cancel',
        },
        {
          type: 'submit',
          label: 'Yes, Already Paid',
          onClick: () => handleConfirm(true),
        },
        {
          type: 'submit_and_continue',
          label: 'No, Not Yet',
          onClick: () => handleConfirm(false),
        },
      ]}
    />
  )
}

export default PaymentReviewModal

PaymentReviewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  dealerId: PropTypes.string.isRequired,
  repairOrderId: PropTypes.string.isRequired,
}
